(function() {
  'use strict';
  angular.module('irricrops')
  .factory('cuartelDialog', cuartelDialog);
  cuartelDialog.$inject = ['$mdDialog'];

  /* @ngInject */
  function cuartelDialog($mdDialog) {
    return {
      showDialog : function(ev, sectorId) {
        $mdDialog.show({
          templateUrl         : 'shared/cuartelDialog/dialogCuartel.view.html',
          parent              : angular.element(document.body),
          targetEvent         : ev,
          locals              : {
            sectorId : sectorId
          },
          clickOutsideToClose : true,
          controllerAs        : "dc",
          controller          : ["sectorId", "CuartelRes", "$mdDialog", "$q", "global",
          function(sectorId, CuartelRes, $mdDialog, $q, global) {

            var vm      = this;
            vm.loading  = false; //true;
            vm.global   = global;

            vm.openMenu = function($mdMenu, ev) {
              $mdMenu.open(ev);
            };

            // var pc = CuartelRes.getData({
            //   sector_riego_id : sectorId,
            //   fecha           : null
            // }).$promise;
            //
            // var pe = CuartelRes.getEstados({
            //   sector_riego_id: sectorId,
            //   fecha: null
            // }).$promise;

             // $q.all({
             //   cuartel: pc,
             //   estados: pe
             // }).then(function(res) {
             //  vm.cuartel = res.cuartel;
             //  vm.loading = false;
             //
             //   var variedades = "";
             //   var calidades = "";
             //   angular.forEach(vm.cuartel.data.variedades, function(variedad){
             //     variedades += variedad.nombre + " ";
             //     calidades += variedad.calidades[0].nombre + " ";
             //   });
             //   global.titleDialogData = [{
             //     name : 'Variedades',
             //     data : variedades
             //   },
             //     {
             //       name : 'Calidades',
             //       data : calidades
             //     },{
             //       name : 'Viñedo',
             //       data : vm.cuartel.data.vinedo_nombre
             //     }];


              vm.tabs = [
                {
                  title        : "IrriView",
                  controller   : "cuartelIrriViewCtrl",
                  controllerAs : "iv",
                  templateUrl  : "components/cuartel/irriview/cuartel.irriview.view.html",
                  locals: {
                    cuartel_id: sectorId,
                    isDialog   : true
                  }
                },
                {
                  title        : "detalles",
                  controller   : "cuartelDetalleCtrl",
                  controllerAs : "ces",
                  templateUrl  : "components/cuartel/detalle/cuartel.detalle.view.html",
                  // locals: {
                  //   cuartel: res.cuartel
                  // }
                  locals: {
                    cuartel_id : sectorId,
                    isDialog   : true
                  }
                },
                  /*
                {
                  title        : "comparacion",
                  templateUrl  : "components/cuartel/comparacion/cuartel.comparacion.view.html",
                  controller   : 'cuartelComparacionCtrl',
                  controllerAs : 'cc',
                  locals: {
                    cuartel: res.cuartel
                  }
                },
                */
                // {
                //   title        : "fenologia",
                //   controller   : 'cuartelEstadosCtrl',
                //   controllerAs : 'cest',
                //   templateUrl  : "components/cuartel/estados/cuartel.estados.view.html",
                //   locals       : {
                //     cuartelEstados : res.estados,
                //     cuartel: res.cuartel
                //   }
                // },
              ];

              vm.currentTab = null;
              vm.selectTab = function(tab) {
                vm.currentTab = tab;
              }
              vm.selectTab(vm.tabs[0]);

            // });

            vm.close = function() {
              $mdDialog.cancel();
            };
          }],
        });
      }
    }
  }
})();
